<template>
  <div class="create-plan-wrapper">
    <div class="header">
      新建计划
    </div>
    <div class="content">
      <a-form ref="valueRef" layout="vertical" :hideRequiredMark="true" :rules="rules" :model="planBody" labelAlign="left">
        <!-- 计划名称 -->
        <a-form-item label="计划名称" name="name" :labelCol="{span: 23}">
          <a-input style="background: black;" placeholder="请输入计划名称" v-model:value="planBody.name"/>
        </a-form-item>
        <!-- 任务类型 -->
        <a-form-item label="任务类型" class="plan-timer-form-item">
          <div style="white-space: nowrap;">
            <a-radio-group v-model:value="planBody.wayline_task_type" button-style="solid" @change="waylineTypeChange">
              <a-radio-button style="width: 130px;" :value="0">普通任务</a-radio-button>
              <a-radio-button style="width: 130px;" :value="1">蛙跳任务</a-radio-button>
            </a-radio-group>
          </div>
        </a-form-item>
        <!-- 航线 -->
        <a-form-item label="执行航线" name="file_id">
          <router-link
            :to="{name: 'select-plan'}"
            @click="selectRoute"
          >
            <a-button type="primary" block>选择航线</a-button>
          </router-link>
        </a-form-item>
        <a-form-item v-if="planBody.file_id" style="margin-top: -15px;">
          <div class="wayline-panel" style="padding-top: 5px;">
            <div class="title">
              <a-tooltip :title="wayline.name">
                <div class="pr10" style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ wayline.name }}</div>
              </a-tooltip>
              <div class="ml10"><UserOutlined /></div>
              <a-tooltip :title="wayline.user_name">
                <div class="ml5 pr10" style="width: 80px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ wayline.user_name }}</div>
              </a-tooltip>
            </div>
            <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
              <span><RocketOutlined /></span>
              <!-- <span class="ml5">{{ Object.keys(EDeviceType)[Object.values(EDeviceType).indexOf(wayline.drone_model_key)] }}</span> -->
              <span class="ml5">{{ EDeviceTypeName[wayline.drone_model_key] }}</span>
              <span class="ml10"><CameraFilled style="border-top: 1px solid; padding-top: -3px;" /></span>
              <span class="ml5" v-for="payload in wayline.payload_model_keys" :key="payload.id">
                <!-- {{ Object.keys(EDeviceType)[Object.values(EDeviceType).indexOf(payload)] }} -->
                {{ EDeviceTypeName[payload] }}
              </span>
            </div>
            <div class="mt5 ml10" style="color: hsla(0,0%,100%,0.35);">
              <span class="mr10">Update at {{ new Date(wayline.update_time).toLocaleString() }}</span>
            </div>
          </div>
        </a-form-item>
        <!-- 设备 -->
        <div v-if="planBody.wayline_task_type === 0">
          <a-form-item label="执行设备" v-model:value="planBody.dock_sn" name="dock_sn">
            <router-link :to="{name: 'select-plan'}" @click="selectDevice">
              <a-button type="primary" block>选择设备</a-button>
            </router-link>
          </a-form-item>
          <a-form-item v-if="planBody.dock_sn" style="margin-top: -15px;">
            <!-- <div class="panel" style="padding-top: 5px;" @click="selectDock(dock)"> -->
            <div class="create-plan-panel" style="padding-top: 5px;">
              <div class="title">
                <a-tooltip :title="dock.nickname">
                  <div class="pr10" style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ dock.nickname }}</div>
                </a-tooltip>
              </div>
              <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
                <span><RocketOutlined /></span>
                <span class="ml5">{{ dock.children?.nickname ?? 'No drone' }}</span>
              </div>
            </div>
          </a-form-item>
        </div>
        <div v-else>
          <a-form-item label="执行设备（起飞）" v-model:value="planBody.dock_sn" name="dock_sn">
            <router-link :to="{name: 'select-plan'}" @click="selectTakeOffDevice">
              <a-button type="primary" block>选择设备</a-button>
            </router-link>
          </a-form-item>
          <a-form-item v-if="planBody.dock_sn" style="margin-top: -15px;">
            <!-- <div class="panel" style="padding-top: 5px;" @click="selectDock(dock)"> -->
            <div class="create-plan-panel" style="padding-top: 5px;">
              <div class="title">
                <a-tooltip :title="dockTakeOff.nickname">
                  <div class="pr10" style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ dockTakeOff.nickname }}</div>
                </a-tooltip>
              </div>
              <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
                <span><RocketOutlined /></span>
                <span class="ml5">{{ dockTakeOff.children?.nickname ?? 'No drone' }}</span>
              </div>
            </div>
          </a-form-item>
          <a-form-item label="执行设备（降落）" v-model:value="planBody.landing_dock_sn" name="landing_dock_sn">
            <router-link :to="{name: 'select-plan'}" @click="selectLaddingDevice">
              <a-button type="primary" block>选择设备</a-button>
            </router-link>
          </a-form-item>
          <a-form-item v-if="planBody.landing_dock_sn" style="margin-top: -15px;">
            <!-- <div class="panel" style="padding-top: 5px;" @click="selectDock(dock)"> -->
            <div class="create-plan-panel" style="padding-top: 5px;">
              <div class="title">
                <a-tooltip :title="dock.nickname">
                  <div class="pr10" style="width: 120px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ dock.nickname }}</div>
                </a-tooltip>
              </div>
              <div class="ml10 mt5" style="color: hsla(0,0%,100%,0.65);">
                <span><RocketOutlined /></span>
                <span class="ml5">{{ dock.children?.nickname ?? 'No drone' }}</span>
              </div>
            </div>
          </a-form-item>
        </div>
        <!-- 任务类型 -->
        <!-- <a-form-item label="任务策略" class="plan-timer-form-item" :labelCol="{span: 23}"> -->
        <a-form-item label="任务精度" class="plan-timer-form-item">
          <div style="white-space: nowrap;">
            <a-radio-group v-model:value="planBody.wayline_precision_type" :disabled="planBody.wayline_task_type === 1" button-style="solid">
              <a-radio-button style="width: 130px;" :value="1">高精度 RTK</a-radio-button>
              <a-radio-button style="width: 130px;" :value="0"> GNSS </a-radio-button>
            </a-radio-group>
          </div>
        </a-form-item>
        <a-form-item label="任务策略" class="plan-timer-form-item">
          <div style="white-space: nowrap;">
            <a-radio-group v-model:value="planBody.task_type" button-style="solid">
              <a-radio-button v-for="type in TaskTypeOptions" style="width: 86px;" :value="type.value" :key="type.value">{{ type.label }}</a-radio-button>
            </a-radio-group>
          </div>
        </a-form-item>
        <!-- 执行日期 -->
        <a-form-item label="执行日期" v-if="planBody.task_type === TaskType.Timed || planBody.task_type === TaskType.Condition" name="select_execute_date" :labelCol="{span: 23}">
          <a-range-picker
            v-model:value="planBody.select_execute_date"
            :disabledDate="(current: Moment) => current < moment().subtract(1, 'days')"
            format="YYYY-MM-DD"
            :placeholder="['开始日期', '结束日期']"
            style="width: 100%;color: #000;background-color: #000;"
            :locale="locale"
          />
        </a-form-item>
        <!-- 执行时间 -->
        <a-form-item label="执行时间" v-if="planBody.task_type === TaskType.Timed || planBody.task_type === TaskType.Condition"
          name="select_execute_time" ref="select_execute_time" :labelCol="{span: 23}" :autoLink="false">
          <div class="mb10 flex-row flex-align-center flex-justify-around" v-for="n in planBody.select_time_number" :key="n">
            <a-time-picker
              v-model:value="planBody.select_time[n - 1][0]"
              format="HH:mm:ss"
              show-time
              placeholder="开始时间"
              style="background: #000;"
              :style="planBody.task_type === TaskType.Condition ? 'width: 39%' : 'width: 82%'"
              @change="() => $refs.select_execute_time.onFieldChange()"
            />
            <template v-if="planBody.task_type === TaskType.Condition">
              <div><span style="color: white;">-</span></div>
              <a-time-picker
                v-model:value="planBody.select_time[n - 1][1]"
                format="HH:mm:ss"
                show-time
                placeholder="结束时间"
                style="width: 40%;background: #000;"
                @change="() => $refs.select_execute_time.onFieldChange()"
              />
            </template>
            <div class="ml5" style="font-size:18px">
              <PlusCircleOutlined class="mr5" style="color: #1890ff" @click="addTime"/>
              <MinusCircleOutlined :style="planBody.select_time_number === 1 ? 'color: gray' : 'color: red;'" @click="removeTime"/>
            </div>
          </div>
        </a-form-item>
        <template v-if="planBody.task_type === TaskType.Condition">
          <!-- battery capacity -->
          <a-form-item label="电池电量达到时启动任务" :labelCol="{span: 23}" name="min_battery_capacity">
            <a-input-number style="background-color: #000;" class="width-100" v-model:value="planBody.min_battery_capacity" :min="50" :max="100"
            :formatter="(value: number) => `${value}%`" :parser="(value: string) => value.replace('%', '')">
            </a-input-number>
          </a-form-item>
          <!-- storage capacity -->
          <a-form-item label="当存储级别达到时启动任务 (MB)" :labelCol="{span: 23}" name="storage_capacity">
            <a-input-number style="background-color: #000;" v-model:value="planBody.min_storage_capacity" class="width-100">
            </a-input-number>
          </a-form-item>
        </template>
        <!-- RTH Altitude Relative to Dock -->
        <a-form-item label="相对机场返航高度RTH(m)" :labelCol="{span: 23}" name="rth_altitude">
          <a-input-number v-model:value="planBody.rth_altitude" style="background: black;" :min="20" :max="1500" class="width-100" required>
          </a-input-number>
        </a-form-item>
        <!-- Lost Action -->
        <a-form-item label="航线飞行中失联" class="plan-timer-form-item" :labelCol="{span: 23}" name="out_of_control_action">
          <div style="white-space: nowrap;">
            <a-radio-group v-model:value="planBody.out_of_control_action" button-style="solid">
              <a-radio-button v-for="action in OutOfControlActionOptions" :disabled="action.value===2" style="width: 132px;" :value="action.value" :key="action.value">
                {{ action.label }}
              </a-radio-button>
            </a-radio-group>
          </div>
        </a-form-item>
        <a-form-item v-if="false" label="是否在模拟器中执行任务" class="plan-timer-form-item" :labelCol="{span: 19}" name="out_of_control_action">
          <div style="white-space: nowrap;">
            <a-switch v-model:checked="getSimulateMissionChecked" @change="onSimulateMissionChange" />
          </div>
        </a-form-item>
        <a-form-item label="模拟点经度" :labelCol="{span: 23}" name="longitude" v-if="getSimulateMissionChecked">
          <a-input-number v-model:value="planBody.longitude" :min="-180.0" :max="180.0" class="width-100">
          </a-input-number>
        </a-form-item>
        <a-form-item label="模拟点纬度" :labelCol="{span: 23}" name="latitude" v-if="getSimulateMissionChecked">
          <a-input-number v-model:value="planBody.latitude" :min="-90.0" :max="90.0" class="width-100">
          </a-input-number>
        </a-form-item>
        <a-form-item class="width-100" style="margin-bottom: 40px;">
          <div class="footer">
            <a-button class="mr10" style="background: #142A49;" @click="closePlan">取消
            </a-button>
            <a-button type="primary" @click="onSubmit" :disabled="disabled">确定
            </a-button>
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
  <div v-if="drawerVisible" style="position: absolute; left: 335px; width: 280px; height: 100vh; float: right; top: 0; z-index: 1000; color: white; background: #051A39;">
    <div>
      <router-view :name="routeName"/>
    </div>
    <div style="position: absolute; top: 15px; right: 10px;">
      <a style="color: white;" @click="closePanel"><CloseOutlined /></a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, reactive, ref, toRaw, UnwrapRef, watch } from 'vue'
import { CloseOutlined, RocketOutlined, CameraFilled, UserOutlined, PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons-vue'
import { ELocalStorageKey, ERouterName } from '/@/types'
import { useMyStore } from '/@/store'
import { WaylineType, WaylineFile, WaylinePoint } from '/@/types/wayline'
import { Device, DEVICE_NAME, EDeviceTypeName } from '/@/types/device'
import { createPlan, CreatePlan, getJobById, deleteWaylineFile, downloadWaylineFile, getWaylineById, getWaylineFiles, importKmzFile } from '/@/api/wayline'
import { BindBody, bindDevice, getDeviceBySn, getPlatformInfo, getUserInfo } from '/@/api/manage'
import { getRoot } from '/@/root'
import { TaskType, OutOfControlActionOptions, OutOfControlAction, TaskTypeOptions } from '/@/types/task'
import moment, { Moment } from 'moment'
import locale from 'ant-design-vue/lib/date-picker/locale/zh_CN'
import 'moment/dist/locale/zh-cn'
import { RuleObject } from 'ant-design-vue/es/form/interface'
import router from '/@/router'
import { message } from 'ant-design-vue'
import X2JS from 'x2js'
import JSZip from 'jszip'
import { get } from 'http'

moment.locale('zh-cn')
const root = getRoot()
const store = useMyStore()

onMounted(() => {
  const jobId = Array.isArray(root.$route.query.id)
    ? root.$route.query.id[0]
    : root.$route.query.id

  if (jobId) {
    // 获取任务详情
    getJobById(workspaceId, jobId).then(res => {
      // 处理响应
      if (res.code === 0) {
        planBody.name = '复制' + res.data.job_name.replace('复制', '')
        planBody.wayline_type = res.data.wayline_type
        // planBody.wayline_precision_type = res.data.precision_type
        planBody.task_type = res.data.task_type
        planBody.rth_altitude = res.data.rth_altitude
        planBody.out_of_control_action = res.data.out_of_control_action
        // 获取航点详情
        getWaylineById(workspaceId, res.data.file_id).then(res1 => {
          if (res1.code === 0) {
            downloadWaylineFile(workspaceId, res.data.file_id).then(res2 => {
              if (!res2) {
                return
              }
              const file = new Blob([res2], { type: 'application/zip' })
              unZipKmz(file, res1.data)
            })
          }
        })
        // 获取dock
        getDeviceBySn(workspaceId, res.data.dock_sn).then(res3 => {
          if (res3.code === 0) {
            const dock = res3.data as Device
            getDeviceBySn(workspaceId, res3.data.child_device_sn).then(res4 => {
              if (res3.code === 0) {
                dock.children = res4.data
                store.commit('SET_SELECT_DOCK_INFO', dock)
              }
            })
          }
        })
      }
    })
  }
})

async function unZipKmz (zipFile: Blob, wayline: WaylineFile) {
  // 判断是否是 .zip 文件
  const isZipFile = zipFile.type === 'application/zip'
  if (!isZipFile) {
    return
  }
  const zip = new JSZip()
  // 解压Zip压缩包，参数默认是二进制
  const zipData = await zip.loadAsync(zipFile)
  await zipData.forEach(function (relativePath, file) {
    // fix: 过滤 mac osx 系统压缩的副作用
    if (!relativePath.startsWith('__MACOSX')) {
      // 判断是否是目录
      if (!file.dir) {
        zip.file(file.name).async('string').then(function (u8) {
          if (file.name === 'wpmz/template.kml') {
            const x2js = new X2JS()
            const jsData: any = x2js.xml2js(u8)
            const kmlData = jsData.kml.Document
            wayline.edit = false
            const waylineType = kmlData.Folder.templateType.__text
            const waylineHeightMode = kmlData.Folder.waylineCoordinateSysParam.heightMode.__text
            const baseHeight = 0
            const kmlPoints = [] as WaylinePoint[]
            // if (kmlData.Folder.Placemark instanceof Array) {
            if (waylineType === 'waypoint') {
              kmlData.Folder.Placemark.forEach((item: any, index: number) => {
                const waypoint = {} as WaylinePoint
                waypoint.index = index
                waypoint.lng = item.Point.coordinates.split(',')[0]
                waypoint.lat = item.Point.coordinates.split(',')[1]
                waypoint.height = item.height.__text
                // 添加机场基础高度
                if (waylineHeightMode === 'relativeToStartPoint') {
                  waypoint.height = Number(item.height.__text) + baseHeight
                }
                kmlPoints.push(waypoint)
              })
            } else if (waylineType === 'mapping2d') {
              const height = kmlData.Folder.Placemark.height.__text
              const polygons = kmlData.Folder.Placemark.Polygon.outerBoundaryIs.LinearRing.coordinates.split('\n')
              polygons.forEach((item: any, index: number) => {
                const waypoint = {} as WaylinePoint
                waypoint.index = index
                waypoint.lng = item.split(',')[0]
                waypoint.lat = item.split(',')[1]
                waypoint.height = height
                // 添加机场基础高度
                if (waylineHeightMode === 'relativeToStartPoint') {
                  waypoint.height = Number(height) + baseHeight
                }
                kmlPoints.push(waypoint)
              })
            } else if (waylineType === 'mapping3d') {
              const height = kmlData.Folder.Placemark.height.__text
              const polygons = kmlData.Folder.Placemark.Polygon.outerBoundaryIs.LinearRing.coordinates.split('\n')
              polygons.forEach((item: any, index: number) => {
                const waypoint = {} as WaylinePoint
                waypoint.index = index
                waypoint.lng = item.split(',')[0]
                waypoint.lat = item.split(',')[1]
                waypoint.height = height
                // 添加机场基础高度
                if (waylineHeightMode === 'relativeToStartPoint') {
                  waypoint.height = Number(height) + baseHeight
                }
                kmlPoints.push(waypoint)
              })
            } else if (waylineType === 'mappingStrip') {
              const height = kmlData.Folder.Placemark.height.__text
              const polygons = kmlData.Folder.Placemark.LineString.coordinates.split('\n')
              polygons.forEach((item: any, index: number) => {
                const waypoint = {} as WaylinePoint
                waypoint.index = index
                waypoint.lng = item.split(',')[0].trim()
                waypoint.lat = item.split(',')[1].trim()
                waypoint.height = height
                // 添加机场基础高度
                if (waylineHeightMode === 'relativeToStartPoint') {
                  waypoint.height = Number(height) + baseHeight
                }
                kmlPoints.push(waypoint)
              })
            } else if (waylineType === 'mappingMatch' || waylineType === 'mappingInspect') {
              const height = kmlData.Folder.Placemark.height.__text
              const polygons = kmlData.Folder.Placemark.Polygon.outerBoundaryIs.LinearRing.coordinates.split('\n')
              polygons.forEach((item: any, index: number) => {
                const waypoint = {} as WaylinePoint
                waypoint.index = index
                waypoint.lng = item.split(',')[0]
                waypoint.lat = item.split(',')[1]
                waypoint.height = height
                // 添加机场基础高度
                if (waylineHeightMode === 'relativeToStartPoint') {
                  waypoint.height = Number(height) + baseHeight
                }
                kmlPoints.push(waypoint)
              })
            }
            wayline.kml = kmlPoints
          }
          if (file.name === 'wpmz/waylines.wpml') {
            const x2js = new X2JS()
            const jsData: any = x2js.xml2js(u8)
            const wpmlData = jsData.kml.Document
            wayline.edit = false
            const wpmlPoints = [] as WaylinePoint[]
            if (wpmlData.Folder instanceof Array) {
              const waylineHeightMode = wpmlData.Folder[0].executeHeightMode.__text
              const baseHeight = 0
              wpmlData.Folder[0].Placemark.forEach((item: any, index: number) => {
                const waypoint = {} as WaylinePoint
                waypoint.index = index
                waypoint.lng = item.Point.coordinates.split(',')[0]
                waypoint.lat = item.Point.coordinates.split(',')[1]
                waypoint.height = item.executeHeight.__text
                // 添加机场基础高度
                if (waylineHeightMode === 'relativeToStartPoint') {
                  waypoint.height = Number(item.executeHeight.__text) + baseHeight
                }
                wpmlPoints.push(waypoint)
              })
            } else {
              const waylineHeightMode = wpmlData.Folder.executeHeightMode.__text
              const baseHeight = 0
              wpmlData.Folder.Placemark.forEach((item: any, index: number) => {
                const waypoint = {} as WaylinePoint
                waypoint.index = index
                waypoint.lng = item.Point.coordinates.split(',')[0]
                waypoint.lat = item.Point.coordinates.split(',')[1]
                waypoint.height = item.executeHeight.__text
                // 添加机场基础高度
                if (waylineHeightMode === 'relativeToStartPoint') {
                  waypoint.height = Number(item.executeHeight.__text) + baseHeight
                }
                wpmlPoints.push(waypoint)
              })
            }
            wayline.wpml = wpmlPoints
            localStorage.setItem(wayline.id, JSON.stringify(wayline))
            store.commit('SET_SELECT_WAYLINE_INFO', wayline)
          }
        })
      }
    }
  })
}

const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!

const wayline = computed<WaylineFile>(() => {
  return store.state.waylineInfo
})

const dock = computed<Device>(() => {
  return store.state.dockInfo
})

const dockTakeOff = ref<Device>()
const dockLadding = ref<Device>()

watch(() => store.state.dockInfo, data => {
  if (data) {
    if (currentTakeOff.value === 0) {
      dockTakeOff.value = data
    } else if (currentTakeOff.value === 1) {
      dockLadding.value = data
    }
    drawerVisible.value = false
    // console.log('dockInfo', data, currentTakeOff.value, dockTakeOff.value, dockLadding.value)
  }
}, {
  deep: true
})

const disabled = ref(false)

const routeName = ref('')
const planBody = reactive({
  name: '',
  file_id: computed(() => store.state?.waylineInfo.id),
  dock_sn: computed(() => dockTakeOff.value?.device_sn),
  landing_dock_sn: computed(() => dockLadding.value?.device_sn),
  task_type: TaskType.Immediate,
  select_execute_date: [] as Moment[],
  select_execute_time: undefined as Moment[] | undefined,
  select_time_number: 1,
  select_time: [[]] as Moment[][],
  // dom: [] as number[],
  rth_altitude: '100',
  out_of_control_action: OutOfControlAction.ReturnToHome,
  min_battery_capacity: 90 as number,
  min_storage_capacity: undefined as number | undefined,
  break_point: '',
  // simulate_mission模拟飞行
  is_enable: 0,
  longitude: 0,
  latitude: 0,
  wayline_precision_type: 1,
  wayline_task_type: 0,
  wayline_type: 0,
})

const drawerVisible = ref(false)
const currentTakeOff = ref(0)
const valueRef = ref()
const rules = {
  name: [
    { required: true, message: '请输入计划名称.' },
    { max: 20, message: '计划名称长度在1~20字之间' }
  ],
  file_id: [{ required: true, message: '请选择航线' }],
  dock_sn: [{ required: true, message: '请选择设备' }],
  landing_dock_sn: [{ required: true, message: '请选择设备' }],
  select_execute_date: [{ required: true, message: '请选择执行日期' }],
  select_execute_time: [{
    validator: async (rule: RuleObject, value: Moment[]) => {
      validEndTime()
      validStartTime()
      if (planBody.select_time.length < planBody.select_time_number) {
        throw new Error('请选择时间')
      }
      validOverlapped()
    }
  }],
  rth_altitude: [
    {
      validator: async (rule: RuleObject, value: string) => {
        if (!/^[0-9]{1,}$/.test(value)) {
          // throw new Error('RTH Altitude Relative Require number')
          throw new Error('请输入有效的相对机场返航高度RTH(m)')
        }
      },
    }
  ],
  longitude: [{ required: true, message: '请输入模拟经度' }],
  latitude: [{ required: true, message: '请输入模拟纬度' }],
  min_battery_capacity: [
    {
      validator: async (rule: RuleObject, value: any) => {
        if (TaskType.Condition === planBody.task_type && !value) {
          throw new Error('请输入电量百分比')
        }
      },
    }
  ],
  out_of_control_action: [{ required: true, message: '请选择失联动作' }],
}

function validStartTime (): Error | void {
  for (let i = 0; i < planBody.select_time.length; i++) {
    if (!planBody.select_time[i][0]) {
      throw new Error('请选择开始时间')
    }
  }
}
function validEndTime (): Error | void {
  if (TaskType.Condition !== planBody.task_type) return
  for (let i = 0; i < planBody.select_time.length; i++) {
    if (!planBody.select_time[i][1]) {
      throw new Error('请选择结束时间')
    }
    // if (planBody.select_time[i][0] && planBody.select_time[i][1].isSameOrBefore(planBody.select_time[i][0])) {
    //   throw new Error('结束时间应晚于开始时间')
    // }
    // 检查结束时间是否晚于开始时间
    if (!planBody.select_time[i] || !planBody.select_time[i][0] || !planBody.select_time[i][1]) {
      throw new Error('请确保 开始时间 和 结束时间 均已设置')
    }

    const startTime = planBody.select_time[i][0]
    const endTime = planBody.select_time[i][1]
    if (endTime.valueOf() < startTime.valueOf()) {
      throw new Error('请确保 结束时间 晚于 开始时间')
    }
    // if (endTime.isSameOrBefore(startTime)) {
    //   throw new Error(`计划时间数组中第 ${i} 项的结束时间应晚于开始时间。当前开始时间为 ${startTime.format('YYYY-MM-DD HH:mm:ss')}，结束时间为 ${endTime.format('YYYY-MM-DD HH:mm:ss')}`)
    // }
  }
}
function validOverlapped (): Error | void {
  if (TaskType.Condition !== planBody.task_type) return
  const arr = planBody.select_time.slice()
  arr.sort((a, b) => a[0].unix() - b[0].unix())
  arr.forEach((v, i, arr) => {
    if (i > 0 && v[0] < arr[i - 1][1]) {
      throw new Error('时间重复')
    }
  })
}

const getSimulateMissionChecked = computed(() => {
  return planBody.is_enable === 1
})

function waylineTypeChange () {
  if (planBody.wayline_task_type === 0) {
    planBody.wayline_precision_type = 1
  } else {
    planBody.wayline_precision_type = 1
  }
}

function onSimulateMissionChange (val: any) {
  if (val) {
    planBody.is_enable = 1
  } else {
    planBody.is_enable = 0
  }
}

// 封装日期范围遍历逻辑
function generateUnixTimestampsInRange (startDate: any, endDate: any) {
  // if (!(startDate instanceof Date && endDate instanceof Date)) {
  //   throw new Error('startDate 和 endDate 必须是有效的 Date 对象')
  // }
  if (startDate > endDate) {
    throw new Error('startDate 必须早于或等于 endDate')
  }

  const result = []
  let currentDate = new Date(startDate) // 避免修改原始对象

  while (currentDate <= endDate) {
    result.push(Math.floor(currentDate.getTime() / 1000)) // 转换为 Unix 时间戳
    currentDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000) // 手动加一天
  }

  return result
}

function onSubmit () {
  valueRef.value.validate().then(() => {
    disabled.value = true
    const createPlanBody = { ...planBody } as unknown as CreatePlan
    if (planBody.wayline_task_type === 0) {
      createPlanBody.landing_dock_sn = ''
    }
    if (createPlanBody.dock_sn === createPlanBody.landing_dock_sn) {
      message.error('起飞机场和降落机场相同，请重新选择!')
      return
    }
    if (planBody.select_execute_date.length === 2) {
      createPlanBody.task_days = []
      // for (let i = planBody.select_execute_date[0]; i.valueOf() < planBody.select_execute_date[1].valueOf(); i.add(1, 'days')) {
      //   createPlanBody.task_days.push(i.unix())
      // }
      createPlanBody.task_days = generateUnixTimestampsInRange(
        planBody.select_execute_date[0],
        planBody.select_execute_date[1]
      )
      // console.log('i', planBody.select_execute_date.length, createPlanBody.task_days)
    }
    createPlanBody.task_periods = []
    if (TaskType.Immediate !== planBody.task_type) {
      for (let i = 0; i < planBody.select_time.length; i++) {
        const result = []
        result.push(planBody.select_time[i][0].unix())
        if (TaskType.Condition === planBody.task_type) {
          result.push(planBody.select_time[i][1].unix())
        }
        createPlanBody.task_periods.push(result)
      }
      // console.log('i', planBody.select_time.length, createPlanBody.task_periods)
    }
    createPlanBody.rth_altitude = Number(createPlanBody.rth_altitude)
    if (wayline.value && wayline.value.template_types && wayline.value.template_types.length > 0) {
      createPlanBody.wayline_type = wayline.value.template_types[0]
    }
    localStorage.setItem(createPlanBody.dock_sn, JSON.stringify(createPlanBody))
    // console.log('createPlanBody', createPlanBody)
    createPlan(workspaceId, createPlanBody)
      .then(res => {
        if (res.code === 0) {
          message.success('任务创建成功')
          closePlan()
        }
      }).finally(() => {
        disabled.value = false
      })
  }).catch((e: any) => {
    console.log('validate err', e)
  })
}

function closePlan () {
  root.$router.push('/' + ERouterName.TASK)
}

function closePanel () {
  drawerVisible.value = false
  routeName.value = ''
}

function selectRoute () {
  drawerVisible.value = true
  routeName.value = 'WaylinePanel'
}

function selectDevice () {
  drawerVisible.value = true
  routeName.value = 'DockPanel'
  currentTakeOff.value = 0
}

function selectTakeOffDevice () {
  drawerVisible.value = true
  routeName.value = 'DockPanel'
  currentTakeOff.value = 0
}

function selectLaddingDevice () {
  drawerVisible.value = true
  routeName.value = 'DockPanel'
  currentTakeOff.value = 1
}

function addTime () {
  valueRef.value.validateFields(['select_execute_time']).then(() => {
    planBody.select_time_number++
    planBody.select_time.push([])
  })
}
function removeTime () {
  if (planBody.select_time_number === 1) return
  planBody.select_time_number--
  planBody.select_time.splice(planBody.select_time_number)
}
</script>

<style lang="scss">
.dayselect{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .dayselectitem{
    width: 46px;
    margin: 2px;
    background: #3c3c3c;
  }
}

.create-plan-wrapper {
  background-color: #051A39;
  color: fff;
  padding-bottom: 0;
  // height: 90vh;
  display: flex;
  flex-direction: column;
  width: 285px;
  height: calc(100vh - 102px);
  overflow-y: auto;

  .header {
    height: 52px;
    line-height: 52px;
    border-bottom: 1px solid #020a1e;
    font-weight: 700;
    font-size: 16px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  .content {
    height: calc(100% - 54px);
    overflow-y: auto;

    form {
      margin: 10px;
    }

    form label, input, .ant-input, .ant-calendar-range-picker-separator,
    .ant-input:hover, .ant-time-picker .anticon, .ant-calendar-picker .anticon {
      // background-color: #232323;
      color: #fff;
    }

    .ant-input-suffix, .ant-picker-separator {
      color: #fff;
    }

    .ant-picker-input ::placeholder {
      color: #c9c7c7;
    }

    .plan-timer-form-item {

      .ant-radio-button-wrapper{
        background-color: #232323;
        color: #fff;
        width: 33%;
        text-align: center;
        &.ant-radio-button-wrapper-checked{
          background-color: #1890ff;
        }
      }
    }
  }

  .footer {
    display: flex;
    padding:10px 0;

    button {
      width: 45%;
      color: #fff ;
      border: 0;
    }
  }
}

.wayline-panel {
  background: #142A49;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 90px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  .title {
    display: flex;
    color: white;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.create-plan-panel {
  background: #142A49;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  height: 70px;
  width: 95%;
  font-size: 13px;
  border-radius: 2px;
  cursor: pointer;
  .title {
    display: flex;
    color: white;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}
</style>
